<template>
  <div class="content">
    <div>
      <p class="titleName">{{ $t('special.p19')}}</p>
      <pre v-text="$t(pageInfo.gender==='male'?'special.p100':'special.p20')" />
    </div>
    <div>
      <p class="titleName">{{ $t('special.p21') }}</p>
      <p>{{ $t(displayData.roleName) }}</p>
       <i18n path="special.p22" tag="p">
        <p
          class="text-decoration-none"
          place="name"
        >
         {{ cvText[$route.params.id]}}
        </p>
      </i18n>
    </div>
    <div>
      <p class="titleName">{{ $t('special.p23') }}</p>
      <p>{{ $t('special.p24') }}</p>
      <p>{{ $t('special.p25') }}</p>
      <i18n path="special.p26" tag="p">
        <a
          class="text-decoration-none"
          place="here"
          :href="displayData.href"
          :download="displayData.downloadName"
        >
          {{ $t('special.p28') }}
        </a>
      </i18n>
    </div>
    <div class="download">
      <p class="titleName">{{ $t('special.p27') }}</p>
      <div class="gif">
        <v-row>
          <v-col
            v-for="(item, i ) in displayData.gifFile"
            :key="i"
            cols="12"
            sm="4"
          >
              <a :href="item.href" :download="item.name">
              <img :src="item.href" :alt="item.name">
            </a>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import { cvText } from '../../configs/special-content'
export default {
  props: ['displayData',"pageInfo"],
  data() {
    return {
      cvText : cvText
    }
  }
}
</script>
<style lang="scss" scoped>
.content{
  margin: 20px 20px 20px 20px;
  text-align: left;
  p, pre{
    color: #ffffff;
    font-weight: 500;
    white-space: pre-wrap;
    &.titleName{
      // font-family: 'Source Han Sans-bold';
      font-size: 32px;
      text-indent: 0em;
    }
    &.subtitleName{
      font-size: 26px;
      text-indent: 0em;
    }
  }
  .download{
    .gif{
      text-align:center;
    }
    img{
      width: 100%;
      max-width: 240px;
      height: auto;
    }
  }
}
@media only screen and (max-width: 767px) {

}
@media only screen and (max-width: 450px) {
  .content{
    p{
      font-size: 14px;
      &.titleName{
        font-size: 20px;
      }
      &.subtitleName{
        font-size: 18px;
      }
    }
    .download{
      img{
        max-width: 180px;
        -webkit-touch-callout: default;
      }
    }
  }
}
</style>
